<script>
import ModelShow from '../models/show';

export default {
  extends: ModelShow,
  page: {
    title: "Detail JALA Harvests",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_harvests.singular')) }},
    resourceRoute: {default: 'jala_harvests'},
    modelVariable: {default: 'jala_harvest'},
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_harvests.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('jala_harvests.plural')),
          href: "/jala_harvests",
        },
        {
          text: this.model && this.model.id ? this.model['id'] : this.$route.params.key,
          href: `/jala_harvests/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : [{
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.cycle`)),
        item: this.model.cycle,
        value: {
          props: { item: { type: Object, default() { return {} } } },
          template: '<router-link :to="`/jala_cycles/${item.id}`">' +
            '{{ lodash.get(item, "pond.farm.name") }} - {{ lodash.get(item, "pond.name") }} - {{ $moment(lodash.get(item, "started_at")).format("DD MMMM YYYY") }}' +
          '</router-link>'
        }
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.harvested_at`)),
        value: this.$moment(this.model.harvested_at).format('DD MMMM YYYY'),
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.age`)),
        value: this.$numeral(this.model.age).format('0,0'),
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.weight`)),
        value: this.$numeral(this.model.weight).format('0,0.[000]'),
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.selling_price`)),
        value: this.$numeral(this.model.selling_price).format('0,0.[000]'),
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.status`)),
        value: this.model.status,
      }, {
        key: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.remark`)),
        item: this.model.remark,
        value: {
          props: { item: {type: String, default: ''} },
          template: `<span v-html="item || '-'"></span>`
        }
      }]
    }
  },
  methods: {
    delete() {
      return this.$axios.delete(`/jala/harvests/${this.$route.params.key}`)
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/jala/harvests/${this.$route.params.key}`, {
        params: { with: 'cycle.pond.farm' }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    }
  }
}
</script>
